import { Injectable, HostListener, Inject, Directive } from "@angular/core";
import { BehaviorSubject, Observable, Subscriber } from "rxjs";
import { WINDOW } from "./windows.service";
import { ActivatedRoute, Router } from "@angular/router";
// Menu
export interface Menu {
  path?: string;
  title?: string;
  icon?: string;
  type?: string;
  badgeType?: string;
  badgeValue?: string;
  active?: boolean;
  bookmark?: boolean;
  children?: Menu[];
  permission?: string;
}
var pagePermission = localStorage.getItem("userPermission")
  ? localStorage.getItem("userPermission")
  : [""];

@Directive({
  selector: '[appIf]'
})
@Injectable({
  providedIn: "root",
})
export class NavService {
  public screenWidth: any;
  public collapseSidebar: boolean = false;
  public url: any;
  public permission: any;

  constructor(@Inject(WINDOW) private window, private router: Router) {
    this.onResize();
    if (this.screenWidth < 991) {
      this.collapseSidebar = true;
    }
  }

  // Windows width
  @HostListener("window:resize", ["$event"])
  onResize(event?) {
    this.screenWidth = window.innerWidth;
  }

  MENUITEMS: Menu[] = [
    {
      path: "/dashboard/default",
      title: "Dashboard",
      icon: "home",
      type: "link",
      badgeType: "primary",
      active: false,
      permission: "dashboard",
    },
     {
      path: "/media",
      title: "Media",
      icon: "camera",
      type: "link",
      active: false,
      permission: "media",
    },
    {
      title: "Users",
      icon: "user-plus",
      type: "sub",
      active: false,
      permission: "users",
      children: [
        { path: "/users/list", title: "List", type: "link" },
        { path: "/users/create", title: "Create", type: "link" },
      ],
    },
    {
      path: "/permissions/list",
      title: "Permissions",
      icon: "chrome",
      type: "link",
      badgeType: "primary",
      active: false,
      permission: "permissions",
    },
    {
      title: "Master",
      icon: "chrome",
      type: "sub",
      active: false,
      permission: "master",
      children: [
        {
          title: "Branch",
          type: "sub",
          active: false,
          permission: "branch",
          children: [
            { path: "/branch/list", title: "List", type: "link" },
            { path: "/branch/create", title: "Create", type: "link" },
          ],
        },
        {
          title: "Stream",
          type: "sub",
          active: false,
          permission: "stream",
          children: [
            { path: "/stream/list", title: "List", type: "link" },
            { path: "/stream/create", title: "Create", type: "link" },
          ],
        },
        {
          title: "Degree",
          type: "sub",
          active: false,
          permission: "degree",
          children: [
            { path: "/degree/list", title: "List", type: "link" },
            { path: "/degree/create", title: "Create", type: "link" },
          ],
        },
        {
          title: "Course",
          type: "sub",
          active: false,
          permission: "course",
          children: [
            { path: "/course/list", title: "List", type: "link" },
            { path: "/course/create", title: "Create", type: "link" },
          ],
        },
        {
          title: "University",
          type: "sub",
          active: false,
          permission: "university",
          children: [
            { path: "/university/list", title: "List", type: "link" },
            { path: "/university/create", title: "Create", type: "link" },
          ],
        },
        {
          title: "Rankings",
          type: "sub",
          active: false,
          permission: "rankings",
          children: [
            { path: "/rankings/list", title: "List", type: "link" },
            { path: "/rankings/create", title: "Create", type: "link" },
          ],
        },
        {
          title: "Onlineexam",
          type: "sub",
          active: false,
          permission: "onlineexam",
          children: [
            { path: "/onlineexam/list", title: "List", type: "link" },
            { path: "/onlineexam/create", title: "Create", type: "link" },
          ],
        },
        {
          title: "Rounds",
          type: "sub",
          active: false,
          permission: "rounds",
          children: [
            { path: "/rounds/list", title: "List", type: "link" },
            { path: "/rounds/create", title: "Create", type: "link" },
          ],
        },
        {
          title: "Program type",
          type: "sub",
          active: false,
          permission: "programtype",
          children: [
            { path: "/programtype/list", title: "List", type: "link" },
            { path: "/programtype/create", title: "Create", type: "link" },
          ],
        },
        {
          title: "Type of college",
          type: "sub",
          active: false,
          permission: "typeofcollege",
          children: [
            { path: "/typeofcollege/list", title: "List", type: "link" },
            { path: "/typeofcollege/create", title: "Create", type: "link" },
          ],
        },
        {
          title: "Gender Accepted",
          type: "sub",
          active: false,
          permission: "genderaccepted",
          children: [
            { path: "/genderaccepted/list", title: "List", type: "link" },
            { path: "/genderaccepted/create", title: "Create", type: "link" },
          ],
        },
        {
          title: "Course Duration",
          type: "sub",
          active: false,
          permission: "courseduration",
          children: [
            { path: "/courseduration/list", title: "List", type: "link" },
            { path: "/courseduration/create", title: "Create", type: "link" },
          ],
        },
        {
          title: "Caste Category",
          type: "sub",
          active: false,
          permission: "castecategory",
          children: [
            { path: "/castecategory/list", title: "List", type: "link" },
            { path: "/castecategory/create", title: "Create", type: "link" },
          ],
        },
        {
          title: "Modules",
          type: "sub",
          active: false,
          permission: "modules",
          children: [
            { path: "/modules/list", title: "List", type: "link" },
            { path: "/modules/create", title: "Create", type: "link" },
          ],
        },
        {
          title: "Facilities",
          type: "sub",
          active: false,
          permission: "facilities",
          children: [
            { path: "/facilities/list", title: "List", type: "link" },
            { path: "/facilities/create", title: "Create", type: "link" },
          ],
        },
        {
          title: "Specialization",
          type: "sub",
          active: false,
          permission: "specialization",
          children: [
            {
              path: "/specialization/list",
              title: "Specialization List",
              type: "link",
            },
            {
              path: "/specialization/create",
              title: "Create Specialization",
              type: "link",
            },
          ],
        },
        {
          title: "Country",
          type: "sub",
          active: false,
          permission: "country",
          children: [
            { path: "/country/list", title: "List", type: "link" },
            { path: "/country/create", title: "Create", type: "link" },
          ],
        },
        {
          title: "State",
          type: "sub",
          active: false,
          permission: "state",
          children: [
            { path: "/state/list", title: "List", type: "link" },
            { path: "/state/create", title: "Create", type: "link" },
          ],
        },
        {
          title: "City",
          type: "sub",
          active: false,
          permission: "city",
          children: [
            { path: "/city/list", title: "List", type: "link" },
            { path: "/city/create", title: "Create", type: "link" },
          ],
        },
        {
          title: "Approved By",
          type: "sub",
          active: false,
          permission: "approved-by",
          children: [
            { path: "/approved-by/list", title: "List", type: "link" },
            { path: "/approved-by/create", title: "Create", type: "link" },
          ],
        },
        {
          title: "Keywords",
          type: "sub",
          active: false,
          permission: "keywords",
          children: [
            { path: "/keywords/list", title: "List", type: "link" },
            { path: "/keywords/create", title: "Create", type: "link" },
          ],
        },
        {
          title: "Ownership",
          type: "sub",
          active: false,
          permission: "ownership",
          children: [
            { path: "/ownership/list", title: "List", type: "link" },
            { path: "/ownership/create", title: "Create", type: "link" },
          ],
        },
         {
          title: "Intake Sessions",
          type: "sub",
          active: false,
          permission: "intakesession",
          children: [
            { path: "/intakesession/list", title: "List", type: "link" },
            { path: "/intakesession/create", title: "Create", type: "link" },
          ],
        },
        {
          title: "Deliverymode",
          type: "sub",
          active: false,
          permission: "deliverymode",
          children: [
            { path: "/deliverymode/list", title: "List", type: "link" },
            { path: "/deliverymode/create", title: "Create", type: "link" },
          ],
        },
        {
          title: "Tags",
          type: "sub",
          active: false,
          permission: "tags",
          children: [
            { path: "/tags/list", title: "List", type: "link" },
            { path: "/tags/create", title: "Create", type: "link" },
          ],
        },
        {
          title: "Accredition",
          type: "sub",
          active: false,
          permission: "accreditions",
          children: [
            { path: "/accreditions/list", title: "List", type: "link" },
            { path: "/accreditions/create", title: "Create", type: "link" },
          ],
        },
        {
          title: "Amenities",
          type: "sub",
          active: false,
          permission: "amenities",
          children: [
            { path: "/amenities/list", title: "List", type: "link" },
            { path: "/amenities/create", title: "Create", type: "link" },
          ],
        },
        {
          title: "Listings",
          type: "sub",
          active: false,
          permission: "listings",
          children: [
            { path: "/listings/list", title: "List", type: "link" },
            { path: "/listings/create", title: "Create", type: "link" },
          ],
        },
      ],
    },
    {
      title: "College Details",
      icon: "chrome",
      type: "sub",
      active: false,
      permission: "college-details",
      children: [
        {
          title: "Waiting For Approval",
          type: "sub",
          active: false,
          children: [
            {
              path: "/college-details/college-form-list",
              title: "Waiting For Approval View",
              type: "link",
            },
             {
              path: "/college-details/waiting-for-approval",
              title: "Waiting For Approval List",
              type: "link",
            },
            
           
          ],
        },
        {
          title: "College",
          type: "sub",
          active: false,
          children: [
            {
              path: "/college-details/college-info-list",
              title: "College List",
              type: "link",
            },
            {
              path: "/college-details/add-college-info",
              title: "Create College",
              type: "link",
            },
          ],
        },
        {
          title: "College Info Details",
          type: "sub",
          active: false,
          children: [
            {
              path: "/college-details/college-info-details-list",
              title: "College Info Details List",
              type: "link",
            },
            {
              path: "/college-details/add-college-details-info",
              title: "Create College Details Info",
              type: "link",
            },
          ],
        },
        {
          title: "College Contact",
          type: "sub",
          active: false,
          children: [
            {
              path: "/college-details/college-contact-list",
              title: "College Contact List",
              type: "link",
            },
            {
              path: "/college-details/add-college-contact",
              title: "Create College Contact",
              type: "link",
            },
          ],
        },
        {
          title: "College Ranking",
          type: "sub",
          active: false,
          children: [
            {
              path: "/college-details/college-ranking-list",
              title: "College Ranking List",
              type: "link",
            },
            {
              path: "/college-details/add-college-ranking",
              title: "Create College Ranking",
              type: "link",
            },
          ],
        },
        {
          title: "College University",
          type: "sub",
          active: false,
          children: [
            {
              path: "/college-details/college-university-list",
              title: "College University List",
              type: "link",
            },
            {
              path: "/college-details/add-college-university",
              title: "Create College University",
              type: "link",
            },
          ],
        },
        {
          title: "College Address",
          type: "sub",
          active: false,
          children: [
            {
              path: "/college-details/college-address-list",
              title: "College Address List",
              type: "link",
            },
            {
              path: "/college-details/add-college-address",
              title: "Create College Address",
              type: "link",
            },
            
          ],
        },
        {
          title: "College Accreditation ",
          type: "sub",
          active: false,
          children: [
            {
              path: "/college-details/college-accreditation-list",
              title: "College accreditation  List",
              type: "link",
            },
            {
              path: "/college-details/add-college-accreditation",
              title: "Create College accreditation ",
              type: "link",
            },
          ],
        },
        {
          title: "College Branch Details",
          type: "sub",
          active: false,
          children: [
            {
              path: "/college-details/college-branch-details-list",
              title: "College Branch Details List",
              type: "link",
            },
            {
              path: "/college-details/add-college-branch-details",
              title: "Create College Branch Details",
              type: "link",
            },
          ],
        },
        {
          title: "College Application",
          type: "sub",
          active: false,
          children: [
            {
              path: "/college-details/college-application-list",
              title: "College Application List",
              type: "link",
            },
           /*  {
              path: "/college-details/add-college-application",
              title: "Create College Application",
              type: "link",
            },
             {
              path: "/college-details/view-college-application",
              title: "View College Application",
              type: "link",
            }, */
          ],
        },
        {
          title: "College EntranceExam",
          type: "sub",
          active: false,
          children: [
            {
              path: "/college-details/college-entranceexam-list",
              title: "College EntranceExam List",
              type: "link",
            },
            {
              path: "/college-details/add-college-entranceexam",
              title: "Create College EntranceExam",
              type: "link",
            },
          ],
        },
        {
          title: "College Document",
          type: "sub",
          active: false,
          children: [
            {
              path: "/college-details/college-document-list",
              title: "College Document List",
              type: "link",
            },
            {
              path: "/college-details/add-college-document",
              title: "Create College Document",
              type: "link",
            },
          ],
        },
        {
          title: "College Gallery",
          type: "sub",
          active: false,
          children: [
            {
              path: "/college-details/college-gallery-list",
              title: "College Gallery List",
              type: "link",
            },
            {
              path: "/college-details/add-college-gallery",
              title: "Create College Gallery",
              type: "link",
            },
          ],
        },
        {
          title: "College Placement",
          type: "sub",
          active: false,
          children: [
            {
              path: "/college-details/college-placement-list",
              title: "College Placement List",
              type: "link",
            },
            {
              path: "/college-details/add-college-placement",
              title: "Create College Placement",
              type: "link",
            },
          ],
        },
        {
          title: "College Course Details",
          type: "sub",
          active: false,
          children: [
            {
              path: "/college-details/college-course-details-list",
              title: "College Course Details List",
              type: "link",
            },
            {
              path: "/college-details/add-college-course-details",
              title: "Create College Course Details",
              type: "link",
            },
          ],
        },
        {
          title: "College Scholarship",
          type: "sub",
          active: false,
          children: [
            {
              path: "/college-details/college-scholarship-list",
              title: "College Scholarship List",
              type: "link",
            },
            {
              path: "/college-details/add-college-scholarship",
              title: "Create College Scholarship",
              type: "link",
            },
          ],
        },
        {
          title: "College Reviews",
          type: "sub",
          active: false,
          children: [
            {
              path: "/college-details/college-reviews-list",
              title: "College Reviews List",
              type: "link",
            },
            {
              path: "/college-details/add-college-reviews",
              title: "Create College Reviews",
              type: "link",
            },
          ],
        },
        {
          title: "College News",
          type: "sub",
          active: false,
          children:[
            {
              path: "/college-details/college-news-list",
              title: "College News List",
              type: "link",
            },
            {
              path: "/college-details/add-college-news",
              title: "Create College News",
              type: "link",
            },
          ],
        },
      ],
    },
    {
      title: "Student Details",
      icon: "chrome",
      type: "sub",
      active: false,
      permission: "student-details",
      children: [
        {
          title: "Student Userdata",
          type: "sub",
          active: false,
          children: [
            {
              path: "/student-details/student-userdata-list",
              title: "Student Userdata List",
              type: "link",
            },
            {
              path: "/student-details/add-student-userdata",
              title: "Create Student Userdata",
              type: "link",
            },
          ],
        },
        {
          title: "Student Userwishlist",
          type: "sub",
          active: false,
          children: [
            {
              path: "/student-details/student-userwishlist-list",
              title: "Student Userwishlist List",
              type: "link",
            },
            {
              path: "/student-details/add-student-userwishlist",
              title: "Create Student Userwishlist",
              type: "link",
            },
          ],
        },
        {
          title: "Student Usercompare",
          type: "sub",
          active: false,
          children: [
            {
              path: "/student-details/student-usercompare-list",
              title: "Student Usercompare List",
              type: "link",
            },
            {
              path: "/student-details/add-student-usercompare",
              title: "Create Student Usercompare",
              type: "link",
            },
          ],
        },
      ],
    },
  ];
  // Array
  items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
}
